import React,  { useState } from 'react';
import { Routes, Route, Link } from "react-router-dom";
import { Navbar, Nav, Dropdown, Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import bg from './media/bg.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faFileAlt, faBookOpen, faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';

import { createWeb3Modal } from '@web3modal/wagmi/react';
import { WagmiProvider, useAccount, useDisconnect } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Home from './pages/Home.tsx'; // Adjust these imports based on where your components are located
import Profile from './pages/Profile.tsx';
import SearchResults from './pages/SearchResults.tsx';
import * as config from './config.tsx';
// Initialize query client
const queryClient = new QueryClient();

// // Web3Modal Configuration
// const projectId = 'c1b9c358eaed6bb42fcd05e6034d0c36';
// const metadata = {
//   name: 'tgether',
//   description: 'AppKit Example',
//   url: 'https://reown.com/appkit',
//   icons: ['https://assets.reown.com/reown-profile-pic.png']
// };

// // Default to Arbitrum
// const chains = [arbitrumSepolia] as const;
// const config = defaultWagmiConfig({
//   chains,
//   projectId,
//   metadata,
// });
const projectId= process.env.REACT_APP_WALLET_PROJECT_ID as string;
// Create Web3Modal instance
createWeb3Modal({
  wagmiConfig: config.config,
  projectId,
  enableAnalytics: true,
  enableOnramp: true,
});

function App() {
  return (
    <WagmiProvider config={config.config}>
      <QueryClientProvider client={queryClient}>
        <MainComponent />
        <Footer />
      </QueryClientProvider>
    </WagmiProvider>
  );
}

function Footer() {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  const toggleFooter = () => {
    setIsFooterVisible(!isFooterVisible);
  };

  return (
    <>
      <Container>
        <Button
          onClick={toggleFooter}
          variant="info-outline"
          className="footer-toggle-btn"
          style={{
            position: 'fixed',
            bottom: isFooterVisible ? '80px' : '15px',
            right: '9vw',
            zIndex: 1000,
            borderRadius: '50%',
            padding: '10px',
            color: '#7a42f4'
          }}
        >
          <FontAwesomeIcon icon={isFooterVisible ? faAngleDown : faAngleUp} size="sm" />
        </Button>
      </Container>

      {isFooterVisible && (
        <footer
          className="bg-light text-white text-center py-1"
          style={{
            position: 'fixed',
            bottom: '0',
            width: '100%',
            zIndex: 999, // Make sure the footer is on top of other content
          }}
        >
          <Container>
            <Row>
              <Col>
                <a href="https://twitter.com/tgetherio" target="_blank" rel="noopener noreferrer" className="text-white mx-3">
                  <FontAwesomeIcon icon={faTwitter} size="1x" />
                </a>
                <a href="https://docs.tgether.io" target="_blank" rel="noopener noreferrer" className="text-white mx-3">
                  <FontAwesomeIcon icon={faBookOpen} size="1x" />
                </a>
                <a href="https://whitepaper.tgether.io" target="_blank" rel="noopener noreferrer" className="text-white mx-3">
                  <FontAwesomeIcon icon={faFileAlt} size="1x" />
                </a>
                <a href="https://github.com/JosephLeva/learntgether/discussions" target="_blank" rel="noopener noreferrer" className="text-white mx-3">
                  <FontAwesomeIcon icon={faGithub} size="1x" />
                </a>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col>
                <p style={{ fontSize: '0.8rem' }}>&copy; {new Date().getFullYear()} tgether. All rights reserved.</p>
              </Col>
            </Row>
          </Container>
        </footer>
      )}

      {/* Add padding to the bottom of the content to avoid it being hidden by the footer */}
      {isFooterVisible && <div style={{ paddingBottom: '60px' }}></div>}
    </>
  );
}




function MainComponent() {
  const { address, isConnected } = useAccount(); // Get the connected account
  const { disconnect } = useDisconnect();


  const handleDisconnect = async () => {
    try {
      await disconnect();
      console.log('Disconnected successfully');
    } catch (error) {
      console.error('Error during disconnect:', error);
    }
  };

  return (
    <div style={{
      backgroundImage: `url(${bg})`,
      minHeight: '100vh',
      width: '100vw',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      position: 'relative', // Use relative to contain the content
      }}>
      <Container>
        <Navbar bg="transparent" variant="dark" expand="lg">
          <Navbar.Brand style={{
            color: "white",
            fontSize: "2.3rem",
            marginLeft: "4vw",
            border: "2px thick #93c",
            borderRadius: "8px",
            padding: "2px 10px",
            backgroundColor: "#93c",
            marginTop: "14px"
          }} as={Link} to="/">
            <span style={{ color: "#3CD0FF", fontSize: "2.5rem", fontWeight: "bold", textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)" }}>tg</span>
            <span style={{ textShadow: "2px 2px 8px rgba(0, 0, 0, 0.4)" }}>ether</span>
          </Navbar.Brand>
          <Link to="https://docs.tgether.io" style={{ textDecoration: 'none', marginTop:"10px" }}>
          <Nav.Item className="btn btn-outline-info d-none d-md-block"> Docs</Nav.Item>
        </Link>
        
            {isConnected ? (
              <>
                <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-auto" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                <Dropdown align="end" className="d-none d-lg-block">
                  <Dropdown.Toggle as="div" style={{ padding: 0 }}>
                    <div className="account-button-wrapper">
                      <w3m-account-button />
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item as={Link} to="/profile">Profile</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDisconnect()}>Disconnect</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* For small screens, everything inside the hamburger menu */}
                <Nav className="d-lg-none">
                  <Nav.Item className="account-button-wrapper">
                    <w3m-account-button />
                  </Nav.Item>
                  <Nav.Link href="https://docs.tgether.io">Docs</Nav.Link>
                  <Nav.Link as={Link} to="/profile">Profile</Nav.Link>
                  <Nav.Link onClick={() => handleDisconnect()}>Disconnect</Nav.Link>
                </Nav>
                </Navbar.Collapse>

              </>
            ) : (
              <div className='justify-content-end' style={{ display: 'flex', marginLeft: 'auto', marginTop:"10px" }}
              >
              <w3m-button />
              </div>
            )}
        </Navbar>
      </Container>

      {/* Routes Section */}
      <Container style={{marginTop:"1px"}}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/search-results" element={<SearchResults />} />
        </Routes>
      </Container>


    </div>

    
  );
}

export default App;
